module.exports = __webpack_public_path__ + "static/media/app-store.400e34ea.svg";